module.exports = __webpack_public_path__ + "img/Zimbabwe.0e758752.svg";